import { useEffect, useRef } from "react";

export const useTimeout = (callback: () => void, delayMs: number | null) => {
	const callbackRef = useRef(callback);

	useEffect(() => {
		callbackRef.current = callback;
	}, [callback]);

	useEffect(() => {
		if (delayMs === null) return;

		const timer = window.setTimeout(() => {
			callbackRef.current();
		}, delayMs);

		return () => window.clearTimeout(timer);
	}, [delayMs]);
};
